import { links } from 'bzx-common/src/config/appConfig'
import React from 'react'
import ExternalLink from 'shared-components/ExternalLink'
import shopBanner from './shop-banner.jpeg'

export default function Shop() {
  return (
    <div className="shop-grid">
      <div className="panel--simple pos-rel overflow-hidden">
        <img className="shop__banner" src={shopBanner} />
      </div>
      <div className="flex-col">
        <div className="panel--simple md-padded-2 height-100p margin-bottom-1">
          <h3 className="txt-slogan">Get your OOKI Gear!</h3>
          <ul className="list-spaced-2">
            <li>T-Shirts</li>
            <li>Hoodies</li>
            <li>Jackets</li>
            <li>Hats</li>
            <li>Collectibles</li>
          </ul>
        </div>
        <div className="panel--simple md-padded-2 margin-bottom-1 txt-explanation">
          OOKI merch drops are limited and restocks are rare.
        </div>
        <ExternalLink className="btn btn--blue btn--small-corners flex-center" href={links.shop}>
          Shop Now
        </ExternalLink>
      </div>
    </div>
  )
}
